// extracted by mini-css-extract-plugin
export var searchHeader = "_3z-0";
export var searchHeaderDark = "_3z-1";